/**
 * Matriz do QR code.
 *
 * POR QUE UM ARQUIVO SO PARA ISSO: o resto do app nao precisa saber qual
 * biblioteca gera QR. Isolada aqui, trocar de lib e mexer num arquivo — e a
 * escolha foi apertada o suficiente para valer a precaucao (ver abaixo).
 *
 * POR QUE `qrcode-generator` E NAO O PACOTE `qrcode`: o `qrcode` do npm
 * importa `buffer` e `stream` do Node, e o webpack 5 do CRA 5 nao faz mais
 * polyfill disso sozinho — quebraria o build. O `qrcode-generator` e puro
 * browser, sem dependencia nenhuma.
 *
 * POR QUE MATRIZ E NAO IMAGEM: com a matriz booleana, quem desenha decide o
 * tamanho de cada modulo. Numa impressora termica de 203 dpi isso e a
 * diferenca entre ler e nao ler — ver o comentario de `desenharQr` em
 * platform/etiqueta.js.
 */

import qrcode from 'qrcode-generator';

/**
 * @param {string} texto conteudo do QR
 * @param {{ correcao?: 'L'|'M'|'Q'|'H' }} opcoes
 *   correcao 'M' (~15%) e o meio-termo: aguenta um respingo de gordura sem
 *   inflar o QR. 'H' engordaria a matriz e, no mesmo espaco fisico, deixaria
 *   cada modulo menor — que e justamente o que faz falhar.
 * @returns {boolean[][]} matriz quadrada; true = modulo escuro
 */
export function matrizDeQr(texto, { correcao = 'M' } = {}) {
  if (!texto) throw new Error('QR sem conteudo');

  // Tipo 0 = a lib escolhe a menor versao que couber o texto.
  const qr = qrcode(0, correcao);
  qr.addData(texto);
  qr.make();

  const lado = qr.getModuleCount();
  const matriz = [];
  for (let linha = 0; linha < lado; linha += 1) {
    const celulas = [];
    for (let coluna = 0; coluna < lado; coluna += 1) {
      celulas.push(qr.isDark(linha, coluna));
    }
    matriz.push(celulas);
  }
  return matriz;
}

/**
 * Versao do QR que o texto exigiu (1, 2, 3...).
 *
 * Existe para ser TESTADA: cada versao a mais adiciona 4 modulos por lado, e
 * no espaco fixo de uma etiqueta 60x40 isso encolhe cada modulo. Um teste que
 * trava a versao avisa quando alguem alonga a URL — antes de o QR parar de ler
 * no papel, que e onde ninguem quer descobrir.
 */
export function versaoDeQr(texto, opcoes) {
  return (matrizDeQr(texto, opcoes).length - 17) / 4;
}
